/* eslint-disable class-methods-use-this */
// eslint-disable-next-line object-curly-newline
import { User } from "@models/User";
import { getFirestore, getDoc, setDoc, doc, collection, deleteDoc } from "firebase/firestore";
import UserTransactionDataService from "./UserTransactionDataService";
import { removeUndefinedFields } from "@/modules/useFirestoreHelpers";

class UserDataService {
  collectionName = "users";

  userTransactionName = "transactions";

  async save(user: User): Promise<User> {
    const db = getFirestore();
    const cleanedUser = removeUndefinedFields(user);
    await setDoc(doc(db, this.collectionName, user.id), cleanedUser);
    return user;
  }

  async get(id: string): Promise<User | null> {
    const db = getFirestore();
    const docRef = doc(collection(db, this.collectionName), id);
    const data = await getDoc(docRef);
    return data.data()
      ? ({ id: data.id, ...data.data() } as unknown as User)
      : (null as unknown as User);
  }

  async delete(id: string) {
    const db = getFirestore();
    const docRef = doc(collection(db, this.collectionName), id);
    await UserTransactionDataService.deleteUserTransactions(id);
    await deleteDoc(docRef);
  }
}

export default new UserDataService();
